<template>
  <div class="setting" v-loading="loading">
    <el-form
      :inline="true"
      label-position="left"
      label-width="100px"
      class="select-form"
      @submit.native.prevent
    >
      <el-form-item label="用户名称">
        <el-input
          v-model="search.username"
          size="small"
          placeholder="请输入查询的用户名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="搜索时间段">
        <el-date-picker
          size="small"
          v-model="search.timer"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" @click="queryFansRank">查询</el-button>
    </el-form>

    <el-table :data="tableData" stripe style="width: 100%" border>
      <el-table-column align="center" prop="user_id" label="用户ID" width="80">
      </el-table-column>
      <el-table-column align="center" prop="avatarUrl" label="用户头像">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.avatarUrl" style="width:60px"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="nickName"
        label="用户名称"
      ></el-table-column>
      <el-table-column align="center" prop="mobile" label="联系号码">
      </el-table-column>
      <el-table-column
        align="center"
        prop="first_fans_total"
        label="一级粉丝数"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="second_fans_total"
        label="二级粉丝数"
      >
      </el-table-column>
      <el-table-column align="center" prop="total_fans" label="粉丝总数">
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import RankApi from "@/api/rank.js";
export default {
  data() {
    return {
      loading:true,
      total: 0,
      curPage: 0,
      pageSize: 0,
      search: {
        sort: "",
        username: "",
        timer: [],
      },
      form: "",
      tableData: [
        {
          sort: "",
          avatarUrl: "",
          username: "",
          phone: "17820571021",
          fans_first: "",
          fans_second: "",
          fans_total: "",
        },
        {
          sort: "",
          avatarUrl: "",
          username: "",
          phone: "17820571021",
          fans_first: "",
          fans_second: "",
          fans_total: "",
        },
      ],
    };
  },
  components: {},
  created() {
    this.queryFansRank();
  },
  methods: {
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.queryFansRank();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      console.log(val);
      let self = this;
      self.curPage = val;
      // self.loading = true;
      self.queryFansRank();
    },
    queryFansRank() {
      let self = this;
      let params = {
        username: this.search.username,
        timer: this.search.timer,
      };
      RankApi.queryFansRank(params, false).then((res) => {
        console.log(res.data.data.data);
        self.tableData = res.data.data.data;
        self.pageSize = res.data.data.per_page;
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/plus/rank/fans.vue